import { IconChevronRight } from '@tabler/icons-react';

/** Points right when shut and turns down when open, for anything that expands in place. */
export function ExpandChevron({ expanded, size }: { expanded: boolean; size: number }) {
  return (
    <IconChevronRight
      size={size}
      style={{
        transform: expanded ? 'rotate(90deg)' : undefined,
        transition: 'transform 150ms ease',
        flexShrink: 0,
      }}
    />
  );
}
